import { createTheme } from './utils';

const baseTheme = createTheme({
  primary: 'blue',
  secondary: 'red',
  textBase: 'white',
});

export default baseTheme;
